module.exports = __webpack_public_path__ + "images/raster/app/web/src/assets/pacific-best-logo-b8c7aa33.png";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/pacific-best-logo.png
// module id = ./app/web/src/assets/pacific-best-logo.png
// module chunks = 0